import { Component } from "react"
import PropTypes from "prop-types"
import { map, isEmpty, isObject } from "lodash"
import { Box, Chip, Paper, List, ListItem, ListItemText, Divider, Select, MenuItem, InputLabel, FormControl, Switch, FormControlLabel } from "@mui/material"
import pluralize from "pluralize"
import classNames from "classnames"

function renderSublist(subItems) {
  return <Box component="div" className="tag-chips">
    {map(subItems, ({ label, value }) =>
      <Chip
        key={label}
        className="tag"
        label={<div>
          <span>{label}</span>
          <span className="avatar">{value}</span>
        </div>}
        color="default"
        variant="outlined"
      />,
    )}
  </Box>
}

class ScanSummary extends Component {
  static propTypes = {
    summary: PropTypes.object.isRequired,
    changeUploadOption: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    uploadOption: PropTypes.string,
    targetName: PropTypes.string.isRequired,
    overlappingDates: PropTypes.array,
    type: PropTypes.string.isRequired,
    showOverrideOptions: PropTypes.bool,
  }

  changeUploadOption = (value) => {
    const { changeUploadOption } = this.props
    changeUploadOption(value)
  }

  confirmOptionChange = (ev) => {
    const { value } = ev.target
    this.openConfirmOptionChange(value)
  }

  confirmWatchlistOptionChange = (ev) => {
    const { checked } = ev.target
    if (checked) {
      this.openConfirmOptionChange("clear")
    } else {
      this.changeUploadOption(null)
    }
  }

  openConfirmOptionChange = (value) => {
    const { openDialog, overlappingDates, targetName, summary, type, showOverrideOptions } = this.props
    let dialogText
    let dialogTitle
    let confirmButtonText
    if (value === "replace") {
      if (showOverrideOptions && !overlappingDates) {
        dialogText = `This will overwrite position date that already exist in ${targetName} and upload a total of ${summary.items.numberOfDates.value} found in this file upload.`
        confirmButtonText = "Replace Dates"
      } else {
        dialogText = `This will overwrite position date for ${overlappingDates.length} ${pluralize("date", overlappingDates.length)} that already ${overlappingDates.length === 1 ? "exists" : "exist"} in ${targetName} and upload a total of ${summary.items.numberOfDates.value} found in this file upload.`
        confirmButtonText = `Replace ${overlappingDates.length} ${pluralize("Date", overlappingDates.length)}`
      }

      dialogTitle = "Replace Positions Only on Dates Provided in Upload?"
    } else if (value === "add") {
      dialogTitle = "Upload positions on dates provided in upload?"
      dialogText = `This will upload position dates for ${summary.items.numberOfDates.value} ${pluralize("date", summary.items.numberOfDates.value)} that currently do not exist in ${targetName}.`
      confirmButtonText = `Upload ${summary.items.numberOfDates.value} ${pluralize("Date", summary.items.numberOfDates.value)}`
    } else {
      if (type === "watchlist") {
        dialogText = "This will delete all securities in this watchlist."
      } else {
        dialogText = `This will delete all dates and all positions related to this ${type}.`
      }
      confirmButtonText = "Clear All"
      dialogTitle = `Clear All Position in ${targetName}?`
    }

    openDialog({
      title: dialogTitle,
      contentText: dialogText,
      buttons: [{
        text: confirmButtonText,
        type: "primary",
        action: () => {
          this.changeUploadOption(value)
        },
      }],
    })
  }

  render() {
    const { summary, uploadOption, overlappingDates, showOverrideOptions, type } = this.props
    return <div className="scan-summary-content">
      <Paper elevation={1} square>
        {type === "watchlist" && showOverrideOptions && <>
          <div className="scan-preview-header scan-summary">
            <InputLabel className="upload-option" shrink htmlFor="upload-option">Upload Option</InputLabel>
            <FormControlLabel
              control={
                <Switch
                  checked={!!uploadOption}
                  onChange={this.confirmWatchlistOptionChange}
                  id="upload-option"
                  name="upload-option"
                  value="clear"
                  color="primary"
                />
              }
              label={`Clear all securities in this ${type} prior to upload`}
            />
          </div>
          <Divider />
        </>}
        {type !== "watchlist" && <>
          <div className="scan-preview-header scan-summary">
            {summary.from && summary.to
              && <div className="scan-summary-dates">{`${summary.from} to ${summary.to}`}</div>}
            {(showOverrideOptions || (overlappingDates && overlappingDates.length > 0))
              && <FormControl variant="standard" className="upload-option">
                <InputLabel shrink htmlFor="upload-option">Upload Option*</InputLabel>
                <Select
                  variant="standard"
                  value={uploadOption}
                  onChange={this.confirmOptionChange}
                  inputProps={{ name: "upload-option", id: "upload-option" }}
                >
                  <MenuItem value="" disabled>Select Upload Option</MenuItem>
                  {!isEmpty(overlappingDates) && <MenuItem value="replace">Only replace positions on dates provided in upload</MenuItem>}
                  {isEmpty(overlappingDates) && <MenuItem value="add">Only upload data on the dates provided in this file</MenuItem>}
                  <MenuItem value="clear">Clear all positions in this {type} prior to upload</MenuItem>
                </Select>
              </FormControl>}
          </div>
          <Divider />
        </>}
        <List disablePadding>
          {map(summary.items, (item, i) =>
            <ListItem key={i} className={classNames("scan-summary-item", { tags: isObject(item.value) })} divider disableGutters>
              {!isObject(item.value) ? <>
                <span className="scan-summary-item-label">{item.label}</span>
                <span className="scan-summary-item-value">{item.value}</span>
              </> : <>
                <ListItemText primary={item.label} />
                {renderSublist(item.value)}
              </>}
            </ListItem>,
          )}
        </List>
      </Paper>
    </div>
  }
}

export default ScanSummary
